import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { LabelField } from "components/LabelField";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import React from 'react';
import DatePicker from "react-datepicker";
import Select, { components } from "react-select-v2";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { getIn } from "formik";
import { HintField } from "../HintField";

const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
  height: "48px",  
};

const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "150px",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};
const formatOptionLabel = ({ label, account_id }) => {
  return (
    <div className="dropdown-container" key={account_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};


const getInstallmentOptions = () => {
  let installmentOptions = [];
  for (let i = 2; i <= 24; i++) {
    installmentOptions.push({
      value: i,
      label: `${i} monthly installments`,
    });
  }
  return installmentOptions;
}

const AddInstallmentsPayment = ({ 
  formik, 
  formikKey = "installmentDetails", 
  onInstallmentChange,
  onDateChange,
  installmentValue,
  dateValue,
  manageFromOutside = false,
  installmentFieldLabel = "Installments",
  dateFieldLabel = "Last Installment Date",
  dateRequired = false,
  disabled = false,
}) => {
  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
const cycleName = `${formikKey}.numberOfInstallment`;

const error = getIn(formik.errors, cycleName);
const touched = getIn(formik.touched, cycleName);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
    dateFormate || "mm/dd/yyyy"
  );

  const installOptions = getInstallmentOptions();



  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }


  const getCurrentInstallment = (value) => {
    const findInstallment = installOptions.find((item) => item.value === value);
    return findInstallment || "";
  }


  return (
    <div className="form-row my-5 add-installment-payment">
      <div className="col-12 col-md-5">
        <LabelField title={installmentFieldLabel} mandatory={true} />
        <Select
          {...{
            formik,
            name: `${formikKey}.cycle`,
            checkValidation: false,
          }}
          classNamePrefix="react-select"
          formatOptionLabel={formatOptionLabel}
          options={installOptions}
          styles={colourStyles}
          onChange={(value) => {
             formik.setFieldTouched(`${formikKey}.numberOfInstallment`, true);

            if(onInstallmentChange) return onInstallmentChange(value);
            if(!value) {
              formik.setFieldValue(`${formikKey}.cycle`, "");
              return;
            }
            formik.setFieldValue(`${formikKey}.cycle`, value?.value);
          }}
          value={
            manageFromOutside ? getCurrentInstallment(installmentValue) :
            formik.values?.[formikKey]?.cycle
              ? getCurrentInstallment(formik.values?.[formikKey]?.cycle)
              : ""
          }
          isClearable={true}
          components={{ DropdownIndicator }}
          isDisabled={disabled}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
        {touched && error && (
          <HintField error={error} />
  // <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px" }}>
  //   {error}
  // </div>
)}
      </div>
      <div className="col-12 col-md-5 offset-md-2">
        <LabelField title={dateFieldLabel} mandatory={dateRequired} />
        <DatePicker
          isClearable
          showIcon
          placeholderText={placeholderFormat}
          dateFormat={dateFormate}
          selected={
            manageFromOutside ? dateValue :
            formik?.values?.[formikKey]?.startInstallment &&
            convertUTCToLocalDate(formik?.values?.[formikKey]?.startInstallment)
          }
          minDate={new Date()}
          onChange={(e) => {
            if(onDateChange) return onDateChange(e);
            formik.setFieldValue(`${formikKey}.startInstallment`, e);
            convertLocalToUTCDate(e, `${formikKey}.startInstallment`);
          }}
          customInput={
            <MaskedInput
              pipe={autoCorrectedDatePipe}
              mask={dateMask}
              keepCharPositions={true}
              guide={true}
              style={{
                height: "48px",
                background: "#F3F6F9",
                border: "1px solid #F3F6F9",
                borderRadius: "6px",
                padding: "6px 12px",
                width: "100%",
                color: "#3F4254",
              }}
            />
          }
          disabled={disabled}
        />
      </div>
    </div>
  )
}

export default AddInstallmentsPayment